<template>
    <select
        :class="cssClass"
        :id="id"
        :value="value"
        v-on:change="onChange"
    >
        <template v-if="placeholder">
            <option disabled hidden selected value="">{{ placeholder }}</option>
        </template>
        <slot name="options">
        <option v-for="(option,index) in selectOptions" :key="index" v-bind:value="option.value" :selected="value == option.value">
            {{ option.title }}
        </option>
        </slot>
        <slot></slot>
    </select>
</template>

<script>
export default {

    name: 'InputSelect',

    props: {
        value: '',
        id: {
            type: String,
            default: () => { return 'input-' + Math.floor(Math.random() * 1000000000); }
        },
        isBootstrap: {
            type: Boolean,
            default: false
        },
        isBulma: {
            type: Boolean,
            default: true
        },
        inputSize: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Vælg...'
        },
        options: undefined,
        optionValueProp: String,
        optionTitleProp: String,
    },

    computed: {
        cssClass() {
            const classes = []
            if(this.isBootstrap) {
                classes.push('form-control')
                if(this.inputSize) {
                    classes.push('input-' + this.inputSize)
                }
            }

            return classes.join(' ')
        },

        selectOptions() {
            return this.toValidOptions(this.options);
        }
    },

    methods: {
        onInput(event) {
            this.$emit('input', event.target.value);
        },

        onChange(event) {
            this.$emit('input', event.target.value);
        },

        isValidOptions(options) {
            if(!Array.isArray(options)) {
                return false;
            }
            for(let i=0; i<options.length; i++) {
                if(!this.isValidOption(options[i])) {
                    return false;
                }
            }
            return true;
        },
        isValidOption(option) {
            return (typeof option === 'object' && option !== null && option.hasOwnProperty('value') && option.hasOwnProperty('title'));
        },

        toValidOptions(options) {
            if(this.isValidOptions(options)) {
                return options;
            }

            let optsArray = [];
            for(let key in options) {
                if(options[key] !== null) {
                    let option = {};
                    option.value = this.optionValueProp && typeof options[key][this.optionValueProp] !== 'undefined' ? options[key][this.optionValueProp] : key;
                    if(!this.optionTitleProp && typeof options[key] !== 'object') {
                        option.title = options[key];
                    } else if(this.optionTitleProp && typeof options[key] === 'object' && typeof options[key][this.optionTitleProp] !== 'undefined') {
                        option.title = options[key][this.optionTitleProp];
                    }
                    if(this.isValidOption(option)) {
                        optsArray.push(option);
                    }
                }
            }
            return optsArray;
        },
    },
}
</script>